import { SharesActionTypes } from "./ActionType";
import * as API from "../../../api/SharesAPI";

export const getSharedWithUsersByEntityId = (entityId, params) => (dispatch) => {
  dispatch({
    type: SharesActionTypes.GET_SHARED_WITH_USERS_BY_ENTITY,
    payload: API.getSharedWithUsersByEntityId(entityId, params)
  })
}